import axios from "axios";


//計算廣告是否存在數據
export const adMatch = ((_html, slot) => {
    let event = {};
    try {
        let regex = /\<\!---(.+?)---\>/g
        event = JSON.parse(regex.exec(_html)[1])
    } catch (e) {
        console.log(e);
        if (slot) {
            console.log('廣告ID內容獲取失敗:', slot)
        }
    }

    return event
})

//2019-0917 广告版位刷新逻辑
export const adRefresh = ((solt) => {
    if (solt) {
        googletag.cmd.push(() => {
            let tags = googletag.pubads().getSlots();

            tags.map(function (value, key, arr) {
                if (value.getAdUnitPath() == solt) {
                    googletag.pubads().refresh([tags[key]]);
                }
            })

        })
    }
})


export const dfpImpress = ((event) => {

    let uuid = localStorage.getItem("UUID"),
        adUnit = event.slot.getAdUnitPath(),
        adLineItem = event.lineItemId,
        adCreative = event.creativeId,
        date = new Date().toJSON().slice(0, 10);
    let data = { "es_tag": "dfp_impressions", "uuid": uuid, "adUnit": adUnit, "adLineItem": adLineItem, "adCreative": adCreative, "date": date, "os": "touch" };

    axios.post('https://dc.8891.tw/api/generic', JSON.stringify(data)).then(function (res) { });
})


//滾動到當前廣告位置三分之二 刷新當前廣告位置
export const gooletagPubads = ((index) => {
    try {
        googletag.cmd.push(function () {
            let tags = googletag.pubads().getSlots();
            googletag.pubads().refresh([tags[index]]);
        });
    } catch (e) {

    }
})

//計算廣告版位長度和下標值.
export const slotsExist = ((slots) => {
    let tags = googletag.pubads().getSlots();

    if (tags != undefined && tags != '') {
        let slotsFilter = tags.map(function (value, key, arr) {
            let slot = this.filter(function (v, i) {
                if (v === this.getAdUnitPath()) {
                    return true
                }
                return false
            }, value)
            return slot == '' ? '' : key
        }, slots);

        let slotsFilterEmpty = slotsFilter.filter(function (v, i) {
            if (v !== '') {
                return true
            }
        });

        return slotsFilterEmpty
    }
})


//刪除指定廣告重新渲染
export const adDestroySlots = slots => {
    slots.map((v, i) => (
        googletag.cmd.push(() => {
            let tags = googletag.pubads().getSlots();

            tags.map(function (value, key, arr) {
                if (value.getAdUnitPath() == v) {
                    googletag.destroySlots([tags[key]]);
                }
            })

        })
    ))
}


